import React from 'react'
import { Alert as BsAlert } from 'react-bootstrap'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import Icon from '../Icon'
import classNames from 'classnames'

import '../../../assets/sass/components/feedback/custom-alert.scss'

const Alert = ({
    className,
    variant = "warning",
    icon = faLock,
    iconProps = {},
    children,
    ...props
}) => {
    return (
        <BsAlert {...props} variant={variant} className={classNames('custom-alert', className)}>
            <Icon className="alert-icon" icon={icon} {...iconProps} />
            <span className="alert-text">{children}</span>
        </BsAlert>
    )
}

export default Alert
